import { render } from "./blog_home.vue?vue&type=template&id=37a1a3a0&scoped=true"
import script from "./blog_home.vue?vue&type=script&lang=js"
export * from "./blog_home.vue?vue&type=script&lang=js"

import "./blog_home.vue?vue&type=style&index=0&id=37a1a3a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a1a3a0"]])

export default __exports__